<template>
  <LoadOnVisible v-on:intersected="loadChartData">
    <div
      v-if="notSetWarehouseIdsTotal"
      class="alert alert-warning alert-dismissible fade show"
      role="alert"
    >
      <h4 class="alert-heading">
        {{ notSetWarehouseIdsTotal }} Storefronts don't have a warehouse set!
      </h4>
      <h6>
        Not having a warehouse set means POs might not work properly for these
        storefronts!
      </h6>
      <h6>
        This could cause incorrect reports, wrong reporting of inventory status
        and more. <u>You should fix this as soon as possible!</u>
      </h6>
      <button
        type="button"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
        @click="DismisForAWhile('notSetWarehouseIds')"
      >
        <span aria-hidden="true">×</span>
      </button>
    </div>

    <div
      v-if="notMappedItemsTotal"
      class="alert alert-danger alert-dismissible fade show"
      role="alert"
    >
      <h4 class="alert-heading">
        {{ notMappedItemsTotal }} Products Not Mapped!
      </h4>
      <h6>
        Are you aware there are Storefront products that aren't mapped to any
        WMS Items?
      </h6>
      <h6>
        This could cause incorrect reports, wrong reporting of inventory status
        and more. <u>You should fix this as soon as possible!</u>
      </h6>
      <div>
         <b-button variant="danger"
            :to="{
              name: 'Reports.StorefrontProductStatistics',
              query: { showOnlyRequiresMapping: 'true' }
            }"
          >
           <i class="fa fa-eye"></i>  Map Products Now!
          </b-button>
      </div>
      <button
        type="button"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
        @click="DismisForAWhile('notMappedItemsTotal')"
      >
        <span aria-hidden="true">×</span>
      </button>
    </div>
    <div
      v-if="ordersVirtuallyFailedTotal"
      class="alert alert-info alert-dismissible fade show"
      role="alert"
    >
      <h4 class="alert-heading">
        {{ ordersVirtuallyFailedTotal }} Virtual Orders Not Synced with Warehouse!
      </h4>
      <h6>
        There are storefronts with orders that haven't synced with the virtual warehouse, this is causing the inventory stats to be off. Please review them as soon as possible!
      </h6>
      <div>
        <b-button variant="secondary" :to="{
              name: 'Orders.Index',
              query: { projectId: '', virtuallyFailedToFulfill: 'only' }
            }">
          <i class="fa fa-eye"></i> View Failed Orders
        </b-button>
      </div>

      <button
        type="button"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
        @click="DismisForAWhile('tmpordersVirtuallyFailed')"
      >
        <span aria-hidden="true">×</span>
      </button>
    </div>

  </LoadOnVisible>
</template>

<script>
import { LoadOnVisible } from '@/views/components/custom';
import { myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  mixins: [myCommonDataMixin],
  name: 'DashAlertsAndMore',
  components: {
    LoadOnVisible
  },
  beforeUnmount() {
  },

  data() {
    return {
      tmpNonotMappedItemsTotal: false,
      tmpnotSetWarehouseIds: false,
      tmpordersVirtuallyFailed: false,
      isFiltering: false,
      showFilterModal: false,
      aggreTimer: '00:00',
      refreshTimerSeconds: 0,
      itemsFilters: {
        showDisabled: false,
        dateFilter: '',
        startDate: '',
        endDate: ''
      },
      projectList: []
    };
  },
  computed: {
    notSetWarehouseIdsTotal: {
      get() {
        let total = 0;
        this.projectList.forEach(itm => {
          if (!itm.warehouseId) {
            total += 1;
          }
        });

        let cookkey = 'dismiss_notSetWarehouseIds';

        if (this.$cookie.get(cookkey) || this.tmpnotSetWarehouseIds) {
          if (this.$cookie.get(cookkey) || this.tmpnotSetWarehouseIds) {
            total = 0;
          }
        }
        return total;
      },
      set(old, val) {}
    },
    ordersVirtuallyFailedTotal: {
      get() {
        let total = 0;
        this.projectList.forEach(itm => {
          if (itm.ordersVirtuallyFailed) {
            total += itm.ordersVirtuallyFailed;
          }
        });

        let cookkey = 'dismiss_tmpordersVirtuallyFailed';

        if (this.$cookie.get(cookkey) || this.tmpordersVirtuallyFailed) {
          if (this.$cookie.get(cookkey) || this.tmpordersVirtuallyFailed) {
            total = 0;
          }
        }
        return total;
      },
      set(old, val) {}
    },
    notMappedItemsTotal: {
      get() {
        let total = 0;
        this.projectList.forEach(itm => {
          if (itm.notMappedProds || itm.notMappedProdsProper) {
            total += itm.notMappedProds + itm.notMappedProdsProper;
          }
        });

        let cookkey = 'dismiss_notMappedItemsTotal';

        if (this.$cookie.get(cookkey) || this.tmpNonotMappedItemsTotal) {
          if (this.$cookie.get(cookkey) || this.tmpNonotMappedItemsTotal) {
            total = 0;
          }
        }
        return total;
      },
      set(old, val) {}
    },

    refreshTimer: {
      get() {
        return this.refreshTimerSeconds;
      },
      set(val, old) {
        if (val != null) {
          if (val < 0) {
            this.refreshTimerSeconds = 10;
          } else {
            this.refreshTimerSeconds = val;
          }
          this.aggreTimer = this.fancyTimeFormat(this.refreshTimerSeconds);
        }
      }
    },
    lastAggregated: {
      get() {
        return this.lastAggregatedDate;
      },
      set(val, old) {
        if (val != null) {
          this.lastAggregatedDate = val;

          var difference = parseInt((new Date() - val) / 1000);
          if (difference > 4 * 60 - 30) {
            difference = 4 * 60;
          } else {
            difference = 4 * 60 - 30 - difference;
          }
          this.refreshTimer = difference;
        }
      }
    }
  },
  mounted() {
  },
  methods: {
    DismisForAWhile(what) {
      this.$cookie.set('dismiss_' + what, true, '1d');
      if (what == 'notMappedItemsTotal') {
        this.tmpNonotMappedItemsTotal = true;
      }
      if(what == 'tmpordersVirtuallyFailed') {
        this.tmpordersVirtuallyFailed = true;
      }
      if (what == 'notSetWarehouseIds') {
        this.tmpnotSetWarehouseIds = true;
      }
    },
    fancyTimeFormat(time) {
      // Hours, minutes and seconds
      var mins = ~~(time / 60);
      var secs = ~~time % 60;

      // Output like "1:01" or "4:03:59" or "123:03:59"
      var ret = '';

      ret += '' + mins + ':' + (secs < 10 ? '0' : '');
      ret += '' + secs;
      return ret;
    },
    loadChartData() {
      this.showFilterModal = false;
      this.isFiltering = true;
      this.$http
        .post('/api/common/manage/storefronts/listItems', {
          ...this.itemsFilters,
          showAll: true
        })
        .then(resp => {
          this.projectList = resp.data.items;
          this.isFiltering = false;
          this.projectList.forEach(it => {
            let now = new Date(it.lastAggregated);
            let lastAggregated = new Date(
              now.getTime() - now.getTimezoneOffset() * 60000
            );
            if (this.lastAggregated < lastAggregated) {
              this.lastAggregated = lastAggregated;
            }
          });
        })
        .catch(err => {});
    }
  }
};
</script>
